<app-shared-drawer [title]="drawerTitle" className="drawer-create-question" [isOpen]="true" (onClose)="handleClose()">
  <div class="position-relative">
    <!-- 🔒 Block UI Overlay -->
    <div class="block-ui-overlay" *ngIf="isRemoving">
      <div class="text-center">
        <div class="spinner-border text-primary mb-2" role="status"></div>
        <div>Removendo elemento...</div>
      </div>
    </div>

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label class="form-control-label"for="label"> Nome da Pergunta * </label>
        <input id="label" class="form-control" formControlName="label"
          placeholder="Este nome será exibido no formulário para o usuário responder." required />
        <app-error-msg label="Nome da Pergunta" [control]="form.controls['label']"></app-error-msg>
      </div>

      <div class="form-group">
        <label class="form-control-label"for="inputType">Tipo de Entrada *</label>
        <ng-select id="inputType" formControlName="inputType" placeholder="Selecione" [items]="questionsTypes"
          (change)="onInputTypeChange($event)" bindValue="value" bindLabel="label" appendTo="body">
          <ng-template ng-option-tmp let-item="item">
            <div class="flex align-items-center">
              <i [data-feather]="item.icon"></i>
              <div class="flex flex-column gap-1 ml-1">
                <span class="ms-2">{{ item.label }}</span>
                <small class="ms-2 text-muted">{{ item.description || 'Descrição do item' }}</small>
              </div>
            </div>
          </ng-template>
        </ng-select>
        <app-error-msg label="Tipo de Entrada" [control]="form.controls['inputType']"></app-error-msg>
        <small class="text-danger" *ngIf="hasNpsConflict">
          Ja existe um campo NPS neste formulario. Altere o tipo de entrada para salvar.
        </small>
      </div>

      <div class="form-group" *ngIf="showChartType && hasChartTypeOptions">
        <label class="form-control-label" for="chartType">Tipo de Gráfico *</label>
        <ng-select
          id="chartType"
          formControlName="chartType"
          placeholder="Selecione o tipo de gráfico"
          [items]="filteredChartTypes"
          bindValue="value"
          bindLabel="label"
          appendTo="body"
        >
        </ng-select>
        <app-error-msg label="Tipo de Gráfico" [control]="form.controls['chartType']"></app-error-msg>
      </div>

      <p
        *ngIf="showChartType && inputTypeField.value && !hasChartTypeOptions"
        class="text-muted small mb-2"
      >
        Este tipo de entrada não possui gráfico no dashboard de indicadores.
      </p>

      <div class="form-group">
        <label class="form-control-label"for="description">Descrição</label>
        <input id="description" class="form-control" placeholder="Descrição" formControlName="description" />
        <app-error-msg label="description" [control]="form.controls['description']"></app-error-msg>
      </div>

      <div class="form-group" *ngIf="showPlaceholder">
        <label class="form-control-label"for="label"> Exemplo de Resposta </label>
        <input id="placeholder" class="form-control"
          placeholder="Texto que aparece dentro do campo antes de o usuário digitar." formControlName="placeholder" />
        <app-error-msg label="Placeholder" [control]="form.controls['placeholder']"></app-error-msg>
      </div>

      <div class="form-group">
        <label class="form-control-label"for="parentItemId">Item Pai</label>
        <ng-select id="parentItemId" formControlName="parentItemId" placeholder="Selecione" [items]="parents"
          bindValue="id" bindLabel="fullLabel" (change)="onParentItemChange($event)">
        </ng-select>
        <app-error-msg label="Item Pai" [control]="form.controls['parentItemId']"></app-error-msg>
      </div>

      <div *ngIf="!isChild" class="form-group">
        <label class="form-control-label"for="order">Ordem</label>
        <input id="order" type="number" placeholder="Ordem" class="form-control" formControlName="order" />
        <app-error-msg label="Ordem" [control]="form.controls['order']"></app-error-msg>
      </div>

      <div class="form-group form-check">
        <input id="required" type="checkbox" class="form-check-input" formControlName="required" />
        <label class="form-control-label"for="required" class="form-check-label">Obrigatória</label>
      </div>

      <div class="form-group" *ngIf="showOptions">
        <label>Opções *</label>
        <div formArrayName="options">
          <div *ngFor="let optionGroup of optionsArray.controls; let i = index" [formGroupName]="i"
            class="row option-row align-items-end mb-2">
            <div class="col">
              <label>Título*</label>
              <input class="form-control" placeholder="Label" formControlName="label" />
              <app-error-msg label="Label" [control]="optionGroup.get('label')"></app-error-msg>
            </div>
            <div class="col">
              <label>Legenda</label>
              <input class="form-control" placeholder="Legenda" formControlName="legend" />
              <app-error-msg label="Legenda" [control]="optionGroup.get('legend')"></app-error-msg>
            </div>
            <div class="col-auto d-flex flex-column option-icon-cell" *ngIf="isRadioOption">
              <label>Ícone</label>
              <button
                type="button"
                class="btn btn-outline-secondary icon-picker-trigger"
                [class.icon-picker-empty]="!optionGroup.get('iconName').value"
                (click)="toggleOptionPicker(i, $event)">
                <ng-container *ngIf="optionGroup.get('iconName').value; else emptyIconPicker">
                  <i class="feather icon-{{ optionGroup.get('iconName').value }}"></i>
                </ng-container>
                <ng-template #emptyIconPicker>
                  + ícone
                </ng-template>
              </button>
              <div
                *ngIf="openOptionPickerIndex === i"
                class="icon-picker-panel"
                [class.is-top]="openOptionPickerPlacement === 'top'"
                [class.is-viewport-positioned]="optionPickerUseViewportPosition"
                [style.top.px]="optionPickerUseViewportPosition ? optionPickerTop : null"
                [style.left.px]="optionPickerUseViewportPosition ? optionPickerLeft : null"
                [style.width.px]="optionPickerUseViewportPosition ? optionPickerWidth : null"
                (click)="$event.stopPropagation()">
                <div   class="icon-picker-title">Escolha um ícone</div>
                <div class="icon-picker-grid">
                  <button
                    *ngFor="let icon of optionPickerIcons"
                    type="button"
                    class="btn btn-icon icon-picker-item"
                    [class.active]="getPendingOptionIcon(optionGroup) === icon"
                    (click)="setPendingOptionIcon(icon)">
                    <i class="feather icon-{{ icon }}"></i>
                  </button>
                </div>
                <div class="icon-picker-footer">
                  <button type="button" class="btn btn-sm btn-danger" [disabled]="!canRemoveOptionIcon" (click)="removeOptionIcon(optionGroup)">Remover</button>
                  <button type="button" class="btn btn-sm btn-primary" [disabled]="!canConfirmOptionIcon" (click)="confirmOptionIcon(optionGroup)">Adicionar</button>
                </div>
              </div>
            </div>
            <div class="col-auto order-col">
              <label>Ordem</label>
              <input type="number" class="form-control order-input" formControlName="order" />
              <app-error-msg label="Ordem" [control]="optionGroup.get('order')"></app-error-msg>
            </div>
            <div class="col-auto">
              <button type="button" class="btn btn-icon text-danger" (click)="removeOption(optionGroup)">
                <i data-feather="trash-2"></i>
              </button>
            </div>
          </div>
        </div>
        <app-error-msg label="Opções" [control]="form.controls['options']"></app-error-msg>
        <div>
          <button type="button" class="btn btn-secondary btn-sm" (click)="addOption()">
            Adicionar opção
          </button>
        </div>
      </div>

      <div class="form-group nps-configurator" *ngIf="isNpsField">
        <label>Escala NPS</label>

        <div class="nps-configurator__card">
          <div class="nps-configurator__scale" aria-hidden="true">
            <span
              *ngFor="let value of npsValues"
              class="nps-configurator__value"
              [ngClass]="{
                'is-negative': value <= 6,
                'is-neutral': value >= 7 && value <= 8,
                'is-positive': value >= 9
              }"
            >
              {{ value }}
            </span>
          </div>

          <div class="nps-configurator__legend">
            <div class="nps-configurator__legend-item is-negative">
              <span class="nps-configurator__emoji">😞</span>
              <span>Detratores</span>
              <small>0 a 6</small>
            </div>

            <div class="nps-configurator__legend-item is-neutral">
              <span class="nps-configurator__emoji">😐</span>
              <span>Neutros</span>
              <small>7 a 8</small>
            </div>

            <div class="nps-configurator__legend-item is-positive">
              <span class="nps-configurator__emoji">😊</span>
              <span>Promotores</span>
              <small>9 a 10</small>
            </div>
          </div>

          <small class="text-muted">
            Escala fixa de 0 a 10. As faixas, cores e emojis seguem o padrão NPS e não são configuráveis.
          </small>
        </div>
      </div>

      <div class="form-group grid-configurator" *ngIf="showGridConfigurator">
        <div class="grid-configurator__header">
          <span>Opções</span>
        </div>

        <div class="grid-configurator__content">
          <section class="grid-configurator__panel">
            <h5 class="grid-configurator__title">Linhas</h5>

            <div
              formArrayName="gridRows"
              class="grid-configurator__list"
              cdkDropList
              [cdkDropListData]="gridRowsArray.controls"
              (cdkDropListDropped)="onGridDimensionDrop($event, gridRowsArray)"
            >
              <div
                *ngFor="let rowGroup of gridRowsArray.controls; let i = index"
                [formGroupName]="i"
                class="grid-configurator__item"
                cdkDrag
              >
                <div class="grid-configurator__handle" aria-hidden="true" cdkDragHandle>
                  <span class="grid-configurator__grip-dots">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                  </span>
                </div>

                <div class="grid-configurator__order">{{ i + 1 }}.</div>

                <div class="grid-configurator__field">
                  <input class="form-control" placeholder="Linha" formControlName="label" />
                  <app-error-msg label="Linha" [control]="rowGroup.get('label')"></app-error-msg>
                </div>

                <button
                  type="button"
                  class="btn btn-icon text-danger"
                  (click)="removeGridRow(i)"
                >
                  <i data-feather="trash-2"></i>
                </button>
              </div>
            </div>

            <div *ngIf="hasDuplicateGridRows" class="text-danger small mb-2">
              As linhas da grade precisam ter nomes únicos.
            </div>

            <button type="button" class="btn btn-secondary btn-sm grid-configurator__add-button" (click)="addGridRow()">
              + Mais linhas
            </button>
          </section>

          <section class="grid-configurator__panel">
            <h5 class="grid-configurator__title">Colunas</h5>

            <div class="grid-configurator__tag-editor">
              <input
                class="form-control"
                formControlName="gridColumnInput"
                placeholder="Digite a coluna e pressione enter"
                (keydown)="onGridColumnInputKeydown($event)"
                (blur)="onGridColumnInputBlur()"
              />

              <div class="grid-configurator__tags" *ngIf="gridColumnsArray.length">
                <button
                  type="button"
                  class="grid-configurator__tag"
                  *ngFor="let columnGroup of gridColumnsArray.controls; let i = index"
                  (click)="removeGridColumn(i)"
                >
                  <span class="grid-configurator__tag-text">{{ columnGroup.get('label')?.value }}</span>
                  <span class="grid-configurator__tag-remove">&times;</span>
                </button>
              </div>
            </div>

            <small class="text-muted grid-configurator__tag-hint">
              Digite e pressione enter para adicionar. Clique na tag para remover.
            </small>
          </section>
        </div>

        <section class="grid-preview" *ngIf="gridRowsArray.length && gridColumnsArray.length">
          <h4 class="grid-preview__title">Exemplo</h4>

          <div class="grid-preview__card">
            <div class="grid-preview__question">{{ form.get('label')?.value || 'Lorem ipsum' }}</div>

            <div class="grid-preview__description" *ngIf="form.get('description')?.value">
              {{ form.get('description')?.value }}
            </div>

            <table class="grid-preview__table">
              <thead>
                <tr>
                  <th></th>
                  <th *ngFor="let columnGroup of gridColumnsArray.controls">
                    {{ columnGroup.get('label')?.value || 'Coluna' }}
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let rowGroup of gridRowsArray.controls">
                  <td class="grid-preview__row-label">{{ rowGroup.get('label')?.value || 'Linha' }}</td>

                  <td *ngFor="let columnGroup of gridColumnsArray.controls; let columnIndex = index">
                    <input
                      *ngIf="isSingleChoiceGrid; else checkboxPreview"
                      type="radio"
                      [checked]="columnIndex === 0"
                      disabled
                    />

                    <ng-template #checkboxPreview>
                      <input type="checkbox" [checked]="columnIndex === 0" disabled />
                    </ng-template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>

      <div class="form-group" *ngIf="isFieldTrueOrFalse">
        <label>Opções</label>

        <div class="form-check mb-2">
          <input
            id="allowNA"
            type="checkbox"
            class="form-check-input"
            formControlName="allowNA"
            (change)="onAllowNaChange($event.target.checked)"
          />
          <label class="form-check-label" for="allowNA">Permitir opção N/A</label>
        </div>

        <div formArrayName="options">
          <div *ngFor="let optionGroup of optionsArray.controls; let i = index" [formGroupName]="i"
            class="row option-row align-items-end mb-2">
            <div class="col">
              <label>Título*</label>
              <input class="form-control" [value]="optionGroup.get('label').value" [disabled]="true" />
              <app-error-msg label="Label" [control]="optionGroup.get('label')"></app-error-msg>
            </div>
            <div class="col-2" *ngIf="i < 2">
              <label>Ícone</label>
              <input
                class="form-control text-center"
                [value]="getTrueOrFalseOptionIcon(i)"
                [disabled]="true"
              />
            </div>
            <div class="col-2">
              <label>Ordem</label>
              <input type="number" class="form-control" [value]="optionGroup.get('order').value" [disabled]="true" />
              <app-error-msg label="Ordem" [control]="optionGroup.get('order')"></app-error-msg>
            </div>
          </div>
        </div>
        <app-error-msg label="Opções" [control]="form.controls['options']"></app-error-msg>
      </div>

      <div class="form-group numeric-scale-config" *ngIf="isNumericScale">
        <label class="form-control-label" for="numericScaleMax">Selecione a escala</label>

        <div class="numeric-scale-range">
          <div class="numeric-scale-value" [style.left.%]="numericScaleThumbLeft">
            {{ numericScaleMaxControl.value }}
          </div>

          <app-slider
            id="numericScaleMax"
            [formControl]="numericScaleMaxControl"
            [min]="2"
            [max]="10"
            [step]="1"
            [showTooltip]="false">
          </app-slider>

          <div class="numeric-scale-range-labels">
            <small>1</small>
            <small>10</small>
          </div>
        </div>

        <div class="numeric-scale-preview card mt-2">
          <div class="card-body p-2">
            <h4 class="mb-1">Exemplo</h4>
            <div class="mb-1">
              <div class="font-weight-bolder">Título da pergunta</div>
              <small class="text-muted">Descrição da pergunta</small>
            </div>

            <div
              class="numeric-scale-preview-grid numeric-scale-preview-grid--numbers"
              [style.gridTemplateColumns]="numericScaleGridTemplate"
            >
              <div *ngFor="let n of numericScalePreviewOptions" class="numeric-scale-preview-cell">
                <small class="text-muted">{{ n }}</small>
              </div>
            </div>
            <div
              class="numeric-scale-preview-grid numeric-scale-preview-grid--radios"
              [style.gridTemplateColumns]="numericScaleGridTemplate"
            >
              <div *ngFor="let n of numericScalePreviewOptions" class="numeric-scale-preview-cell">
                <span class="numeric-scale-preview-radio" [class.is-selected]="n === 1"></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-3 d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-flat-secondary" (click)="handleClose()">
          Cancelar
        </button>
        <button type="submit" class="btn btn-primary"
          [disabled]="isSaveDisabled">Salvar</button>
      </div>
    </form>
  </div>
</app-shared-drawer>